import ENV from "../../env";
import { type SupportedLocale } from "@/shared/culture/locales";
import { loadModuleTranslations, loadTranslations } from "@/shared/culture/translationLoader";
import { useCultureProviderState as useSharedCultureProviderState } from "@/shared/culture/useCultureProviderState";
import type { InitialCulture } from "./bootstrap";
import type { TranslationModule } from "./translationModules.generated";

type TranslationDictionary = Record<string, Record<string, string>>;

type UseCultureProviderStateResult = {
  locale: SupportedLocale;
  translations: TranslationDictionary;
  isCommonReady: boolean;
  ensureModuleLoaded: (moduleName: TranslationModule) => Promise<void>;
  isModuleLoaded: (moduleName: TranslationModule) => boolean;
};

export function useCultureProviderState(initialCulture?: InitialCulture): UseCultureProviderStateResult {
  return useSharedCultureProviderState<TranslationModule>({
    supportedLocalesRaw: ENV.SUPPORTED_LOCALES,
    loadCommonTranslations: loadTranslations,
    loadModuleTranslations,
    initialCulture,
  });
}
